import React, { useEffect, useState } from "react";
import tutorOne from "../../assets/dan.png";
import tutorTwo from "../../assets/paul.png";
import tutorThree from "../../assets/laura.png";
import BackButton from "../../common/backButton/backButton";
import { useNavigate } from "react-router-dom";

const WordFromTutors = () => {
  const navigate = useNavigate();
  const [backScreen, setBackScreen] = useState("");

  useEffect(() => {
    const checkBackScreen = () => {
      const backButtonScreen = localStorage.getItem("previousPage");
      if (backButtonScreen) {
        setBackScreen(backButtonScreen.toString());
      }
    };
    checkBackScreen();
  }, []);
  return (
    <>
      <div className="w-full flex py-4 ">
        <div className="bg-white p-4 shadow-md rounded-3xl xl:w-3/5 ">
          <div className="flex w-full flex-col  xl:flex xl:flex-row">
            <div className="w-full flex xl:w-5/6  xl:flex xl:flex-col">
              <img className="w-1/2 xl:w-full" src={tutorOne} />
              <img className="hidden xl:block" src={tutorTwo} />
              <img className="hidden xl:block" src={tutorThree} />
            </div>
            <div>
              <h3 className="font-bold xl:ml-4">Words From Our Tutors</h3>
              <p className="mt-4 xl:ml-4">
                Welcome to our 5 minute tests where you can profile your current
                ability or complete our practice papers which present you with a
                sample of 11+ exam questions in Maths, English, Verbal and
                Non-verbal reasoning (and soon GCSE Maths). Remember: these
                tools are free resources, designed to give a useful insight.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WordFromTutors;
